import type { DOMAttributes, PropsWithChildren } from "react";
import React from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";

import { StyledRedirectButton } from "./styles";

export type Props = DOMAttributes<HTMLAnchorElement> &
  PropsWithChildren<{ className?: string; url: string }>;

export const RedirectButton: React.FunctionComponent<Props> = ({
  children,
  className,
  onClick,
  url,
  ...props
}) => {
  const { handleRoutePush } = useSdkContext();
  return (
    <StyledRedirectButton
      className={className}
      onClick={event => {
        void handleRoutePush(url);
        onClick?.(event);
      }}
      rel="noreferrer"
      target="_blank"
      {...props}
    >
      {children}
    </StyledRedirectButton>
  );
};

RedirectButton.displayName = "RedirectButton";
